var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressbar__container"},[_c('div',{ref:_vm.refDoProgresso,staticClass:"progressbar__container__value"})])
}
var staticRenderFns = []

export { render, staticRenderFns }